import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../i18n/translate.js';
import '../../../components/Button/Button.js';
import '../../../components/AppLogo/AppLogo.js';
import '../../../components/Avatar/Avatar.js';
import '../../../components/Input/Input.js';
import '../../../components/Input/PasswordInput.js';
import '../../../components/Icon/Icon.js';
import '../../../components/Image/Image.js';
import '../../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../../components/Note/Note.js';
import '../../../components/RadioButton/RadioButton.js';
import '../../../components/RoundButton/RoundButton.js';
import '../../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../../components/Expandable/Expandable.js';
import '../../../components/PopOver/PopOver.js';
import '../../../components/Wizard/Wizard.js';
import '../../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../../components/ToggleButton/ToggleButton.js';
import '../../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../../components/Checkbox/Checkbox.js';
import SelectionField from '../../../components/SelectionField/SelectionField.js';
import '../../../components/Card/Card.js';
import '../../../components/Badge/Badge.js';
import '../../../components/SettingsItem/SettingsItem.js';
import '../../../components/SortableList/SortableList.js';
import '../../../components/Contacts/ContactItem.js';
import '../../../components/TopElement/TopElement.js';
import '../../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../../components/Flag/Flag.js';
import '../../../i18n/i18n.js';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import '../../../services/ipcWeb/ipcService.js';
import '../../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './AccessLevel.module.scss.js';
import { profileMap } from './AccessLevelUtil.js';

function AccessLevel(_ref) {
  var profile = _ref.profile,
    pendingInviteProfile = _ref.pendingInviteProfile,
    onChange = _ref.onChange,
    className = _ref.className,
    AccessLevelHeader = _ref.AccessLevelHeader;
  var isOwner = profile === 'OWNER';
  var accessLevels = /*#__PURE__*/React.createElement(SelectionField, {
    name: "accesslevel",
    onChange: onChange,
    defaultValue: profile,
    disabled: isOwner,
    dataTestId: "accessLevelSelect"
  }, Object.keys(profileMap).filter(function (p) {
    var filter = isOwner ? profileMap[p] === profileMap.OWNER : profileMap[p] !== profileMap.OWNER;
    return filter;
  }).map(function (a) {
    return /*#__PURE__*/React.createElement("p", {
      key: a,
      className: styles.accessLevelItem,
      value: a
    }, t(profileMap[a]), pendingInviteProfile === a && /*#__PURE__*/React.createElement("span", null, "\xA0 (", t('MPLIB_CONTACT_LIST_PENDING'), ")"));
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.accessLevelContainer, className)
  }, AccessLevelHeader, /*#__PURE__*/React.createElement("p", {
    className: classNames('secondary', styles.typeDescription)
  }, t('MPLIB_USERS_PROFILE_TYPE_DESCRIPTION')), accessLevels, isOwner ? /*#__PURE__*/React.createElement("p", {
    className: styles.systemOwnerText
  }, t('MPLIB_USER_OWNER_ACCESS_LEVEL_CHANGE')) : /*#__PURE__*/React.createElement("p", {
    className: classNames('secondary', 'caption', styles.levelInfo)
  }, t("MPLIB_USER_OWNER_ACCESS_LEVEL_".concat(profile, "_INFO"))));
}
AccessLevel.propTypes = {
  profile: PropTypes.string,
  pendingInviteProfile: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  AccessLevelHeader: PropTypes.node
};
AccessLevel.defaultProps = {
  className: '',
  profile: 'NONE',
  pendingInviteProfile: null,
  AccessLevelHeader: null
};

export { AccessLevel as default };
